import { Search } from 'lucide-react';

type Props = {
  value: string;
  onChange: (next: string) => void;
};

const MembersSearchBar = ({ value, onChange }: Props) => (
  <label className="members-search">
    <span className="members-search__icon" aria-hidden="true">
      <Search size={16} />
    </span>
    <input
      type="search"
      className="members-search__input"
      placeholder="Search by name or phone"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      data-testid="members-search-input"
    />
  </label>
);

export default MembersSearchBar;
